// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6071b990","239":"c67a5213","453":"dbbcfe76","732":"2ec0907f"}[chunkId] + ".chunk.js";
};